import { Dmhinhthucguipakn } from './Dmhinhthucguipakn';
import { Dmhuyenthi } from './Dmhuyenthi';
import { Dmlinhvucpakn } from './Dmlinhvucpakn';
import { Dmphanloaipakn } from './Dmphanloaipakn';
import { Dmphuongxa } from './Dmphuongxa';
import { Dmthutuc } from './dmthutuc';
import { Dmtinhthanh } from './Dmtinhthanh';
export class Phananhkiennghi {
    phanAnhID : number;
    hoTen:string;
    diaChi:string;
    dienThoai:string;
    email:string;
    chuDe:string;
    noiDung:string;
    giaiPhap:string;
    taiLieuDinhKem:string;
    ngayGui:Date;
    ketQuaXuLy:string;
    taiLieuXuLy:string;
    hienThi:number;
    isActive:number;
    createdDate:Date;
    createdByUserID:number;
    modifiedByUserID:number;
    modifiedDate:Date;
    dmthutuc:Dmthutuc;
    loai : number;
    loaiToChuc:number;
    cmnd:string;
    ngayCap:Date;
    noiCap:string;
    ngayXuLy:Date;
    donViXuLy:number;
    ngayThuLy:Date;
    ketQuaXL:number;
    duyet:number;
    loaiTin:number;
    maDonVi:string;
    donViID : number;
    showanswer: boolean = false;
    getFiles : string[];
    tenclass: string;
    markread: number;
    iconmoitraloi: string;
    getFilesXuLy : string[];
    hailong: number;
    khonghailong: number;
    
    //capnhat api
    dongbo: number;
    quocgia: number;
    paknquocgiaID: string;
    tongso: number;
    matthc: string;
    noidungtralai: string;
    ngaytralai:Date;
    tieudetralai:string;
    
    dmhinhthucguipakn:Dmhinhthucguipakn;
    hinhthucguipakn : number;
    dmphanloaipakn:Dmphanloaipakn;
    phanloaipakn : number;
    dmlinhvucpakn:Dmlinhvucpakn;
    linhvucpakn : number;

    quanhuyen: Dmhuyenthi;
    quanhuyenid: number;
    phuongxa: Dmphuongxa;
    phuongxaid: number;
    tinhthanhid:number;
    tinhthanh:Dmtinhthanh;

}